import { Form, Formik } from "formik";
import style from "./CreateCost.module.scss";
import * as Yup from 'yup';
import { Button, Input, InputSelect } from "@ui";
import { MdDelete } from "react-icons/md";
import { useCreateCostsTagMutation, useDeleteCostsTagMutation, useGetAllCostsTagsQuery } from "@RTKQuery/admin/costsTags/costsTags";
import { useCreateCostMutation } from "@RTKQuery/admin/cost/cost";

export function CreateCost() {
    const { data } = useGetAllCostsTagsQuery();
    const [createCostsTag, createCostsTagStatus] = useCreateCostsTagMutation();
    const [deleteCostsTag] = useDeleteCostsTagMutation();

    const [createCost, createCostStatus] = useCreateCostMutation()

    return (
        <div className={style.container}>
            <p className={style.label}>Додати витрату</p>
            <Formik
                initialValues={{
                    amount: "",
                    tag: ""
                }}
                validationSchema={Yup.object({
                    amount: Yup.number().typeError("Тільки числа").required("Сума витрат - обов'язкове поле"),
                    tag: Yup.string().required("Тег - обов'язкове поле"),
                })}
                onSubmit={(values) => {
                    createCost({
                        suma: Number(values.amount),
                        tag_id: Number(values.tag)
                    })
                }}
            >
                {(props) => (
                    <Form>
                        <div className="flex justify-between items-start max-lg:flex-col max-lg:items-start gap-[20px]">
                            <div className="flex items-start gap-[20px] max-md:flex-col max-md:w-full">
                                <InputSelect
                                    label="Тип"
                                    name="type"
                                    currentValue={(() => {
                                        const find = data?.find(item => String(item.id) === props.values.tag);

                                        return {
                                            label: find?.name || "",
                                            value: String(find?.id || "-1")
                                        }
                                    })()}
                                    onChange={(newValue) => {
                                        props.setFieldValue("tag", newValue.value)
                                    }}
                                    listValues={data?.map(item => ({
                                        label: "#" + item.name,
                                        value: String(item.id)
                                    })) || []}
                                    customStyle={{
                                        container: style.customInput
                                    }}
                                    onBlur={props.handleBlur}
                                    error={props.touched.tag ? props.errors.tag : ""}
                                    loader={createCostsTagStatus.isLoading}
                                    listValueActions={
                                        (data) => (
                                            <MdDelete
                                                className="cursor-pointer text-[#A2AFD0]"
                                                onClick={() => {
                                                    deleteCostsTag(Number(data.value))
                                                        .unwrap()
                                                        .then(() => {
                                                            if (data.value === props.values.tag) {
                                                                props.setFieldValue("tag", "")
                                                            }
                                                        })
                                                        .catch(() => { })
                                                }}
                                            />
                                        )
                                    }
                                    readOnly={false}
                                    enterAction={(value) => {
                                        if (value) {
                                            createCostsTag({
                                                name: value
                                            })
                                                .unwrap()
                                                .then((data) => {
                                                    props.setFieldValue("tag", String(data.id))
                                                })
                                                .catch(() => { })
                                        }
                                    }}
                                />
                                <Input
                                    label="Сума витрат"
                                    type="text"
                                    onChange={(newValue) => {
                                        props.setFieldValue("amount", newValue.trim())
                                    }}
                                    onBlur={props.handleBlur}
                                    value={String(props.values.amount)}
                                    name="amount"
                                    customStyle={{
                                        width: style.customInput
                                    }}
                                    error={props.touched.amount ? props.errors.amount : ""}
                                />
                            </div>
                            <Button
                                type="submit"
                                text="Додати витрату"
                                customStyle={{
                                    width: "!max-w-[210px] !w-[210px] max-md:!max-w-full max-md:!w-full",
                                    button: "!max-w-[210px] !w-[210px]  !h-[43px] max-md:!w-full  max-md:!max-w-full !px-[45px]",
                                    text: "!text-[14px]"
                                }}
                                successContent={
                                    createCostStatus.isSuccess
                                        ? {
                                            title: "Вітаємо!",
                                            description: <p className="max-w-[260px]">Ви успішно додали витрату!</p>
                                        }
                                        : undefined
                                }
                                loading={createCostStatus.isLoading}
                                errors={[
                                    (createCostStatus.error && ((extractError) => {
                                        return extractError(createCostStatus.error)
                                    }))
                                ]}
                                resetStatus={() => {
                                    createCostStatus.reset();
                                    props.resetForm()
                                }}
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    )
}